import { createAction, createSlice } from '@reduxjs/toolkit';

import { TECHNICAL_ASSESSMENTS } from '../../actions/TechnicalAssessments/actionTypes';

const initialState = {
  isLoading: true,
  technicalAssessmentsData: [],
  skillsList: [],
  technicalAssessmentDetails: {},
  message: '',
  errors: '',
  openTechnicalModal: { open: false, action: null }
};

export const technicalAssessmentsSlice = createSlice({
  name: TECHNICAL_ASSESSMENTS,
  initialState,
  reducers: {
    getTechnicalAssessmentsAction: (state) => {
      state.isLoading = true;
    },
    setTechnicalAssessmentsLoader: (state, action) => {
      state.isLoading = action.payload;
    },
    setTechnicalAssessments: (state, action) => {
      state.technicalAssessmentsData = action.payload.assessments;
      state.skillsList = action.payload.skillArea;
    },
    setTechnicalAssessmentDetails: (state, action) => {
      state.technicalAssessmentDetails = action.payload;
    },
    setTechnicalAssessmentSuccessMessage: (state, action) => {
      state.message = action.payload;
    },
    setTechnicalAssessmentErrorMessage: (state, action) => {
      state.errors = action.payload;
    },
    resetTechnicalAssessmentMessage: (state) => {
      state.message = '';
      state.errors = '';
    },
    setOpenTechnicalModal: (state, action) => {
      state.openTechnicalModal = action.payload;
    }
  }
});

export const saveAssessmentAction = createAction('SAVE_ASSESSMENT');
export const getAssessmentDetailsAction = createAction('GET_ASSESSMENT_DETAILS');

export const {
  setTechnicalAssessments,
  getTechnicalAssessmentsAction,
  setTechnicalAssessmentsLoader,
  setTechnicalAssessmentDetails,
  setTechnicalAssessmentSuccessMessage,
  setTechnicalAssessmentErrorMessage,
  resetTechnicalAssessmentMessage,
  setOpenTechnicalModal
} = technicalAssessmentsSlice.actions;

export default technicalAssessmentsSlice.reducer;
